import React from 'react';
import Spinner from '@xo-union/tk-component-spinner';
import styles from './loader.scss';

const Loader = () => (
  <div className={styles.loaderContainer}>
    <div className={styles.spinnerContainer}>
      <Spinner />
    </div>
  </div>
);

export default Loader;
